import * as React from 'react'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { getImageForRating } from './GetImageForRating'
import { Container } from '../Container'
import { YelpButton } from '../Button'

import defaultImage from '../../../public/img/yelp-business-placeholder.png'

export const ListYelpDataSection: React.FC<{
  locationName: string
  businesses: any[]
  subheading: string
}> = ({ locationName, businesses, subheading }) => {
  return (
    <section>
      <Container>
        <div>
          <h2 className="title text-center">The Top 10 Brake Repair Shops in {locationName}</h2>
          <p className="text-center" style={{ color: '#a6adb4', fontSize: 22 }}>
            {subheading}
          </p>
          <hr />
          {businesses &&
            businesses.length > 0 &&
            businesses.map((business, index) => (
              <React.Fragment key={index}>
                <YelpSectionItem business={business} />
                <hr />
              </React.Fragment>
            ))}
        </div>
      </Container>
    </section>
  )
}

const YelpSectionItem: React.FC<{ business: any }> = ({ business }) => {
  const yelpStars = getImageForRating(business.rating!)
  return (
    <div>
      <div className="grid md:grid-cols-2 py-6">
        <div className="flex flex-row">
          <div className={'pr-4'}>
            {business.photos && (
              // cant use Image because yelp cdn resolution is unpredictable
              <img
                style={{ width: 70, height: 70 }}
                src={
                  business.photos[0] === 'https://s3-media3.fl.yelpcdn.com/bphoto/None/o.jpg'
                    ? defaultImage
                    : business.photos[0]
                }
              />
            )}
          </div>
          <div>
            <h3 style={{ fontSize: 18 }}>{business.name}</h3>
            <div>
              <img src={yelpStars} /> {business.review_count} Reviews
            </div>
            <div>
              {business.location!.address1} {business.location!.city} {business.location!.state}
            </div>
          </div>
        </div>
        <div className="text-right flex flex-col justify-center">
          <a href={`tel:${business.phone}`}>
            <YelpButton>
              <FontAwesomeIcon icon={faPhone} flip={'horizontal'} /> Call Business
            </YelpButton>
          </a>
        </div>
      </div>
      {business.reviews && business.reviews.length > 0 && <YelpReviews reviews={business.reviews!} />}
    </div>
  )
}

const YelpReviews: React.FC<{ reviews: any[] }> = ({ reviews }) => {
  const [isHidden, setIsHidden] = useState(true)
  const reviewsToShow = isHidden ? reviews.slice(0, 1) : reviews
  const showAll = () => {
    setIsHidden(false)
  }
  return (
    <div>
      {reviewsToShow.map((review, index) => (
        <div className="flex flex-row" key={index}>
          <img
            src={review.user!.image_url!}
            style={{
              height: '30px',
              width: '30px',
              borderRadius: '100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: 'cover',
              backgroundColor: '#efefef',
              marginRight: '10px',
            }}
          />
          <div>
            <p>
              {review.text}{' '}
              {isHidden && (
                <button className="text-primary" onClick={showAll}>
                  Show More
                </button>
              )}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}
